import React from 'react'
import {
  GetTagInstructionsContainer,
  LogicalBlock,
  EmailDeveloperContainer,
  EmailError,
  EmailErrorContainer,
} from './Instructions.styled'
import { useTranslation } from 'react-i18next'
import { ButtonWithIcon, Input, StyledText } from '@clickcease/cc-client-components-lib'
import { PapperplaneIcon } from 'Assets/icons/PaperplaneIcon'
import { useEmailForm } from 'src/hooks/useEmailForm'
import { useSendTrackingCodeToEmail } from 'Features/domainsManagement/api/sendTrackingCodeToMail'
import { useAppStore } from 'Stores/appStoreModuleFed'

export const SendCode = ({ domainId }: { domainId: number }) => {
  const { t } = useTranslation('domainManagement')

  const { showToaster } = useAppStore()
  const submitEmail = (email: string) => {
    mutate(email, {
      onSuccess: (res) => {
        const isError = res instanceof Error

        if (!isError) {
          showToaster(t('get_tag_modal.email_steps.email_success', { email: email }), 'success')
        } else {
          setEmailError(t('get_tag_modal.email_steps.email_error', { email: email }))
          showToaster(t('get_tag_modal.email_steps.email_error', { email: email }), 'failure')
        }
      },
    })
  }
  const { email, emailError, onSubmitEmail, handleEmailChange, setEmailError } = useEmailForm({
    errorText: t('get_tag_modal.email_steps.email_wrong_format'),
    submitEmail: submitEmail,
  })

  const { mutate, isLoading } = useSendTrackingCodeToEmail({ domainId })

  return (
    <GetTagInstructionsContainer id={'onboarding-email-developer'}>
      <LogicalBlock>
        <StyledText>{t('get_tag_modal.email_steps.step_1')}</StyledText>
      </LogicalBlock>
      <EmailDeveloperContainer>
        <Input
          value={email}
          placeholder={t('get_tag_modal.email_steps.placeholder')}
          onChange={handleEmailChange}
        />
        <EmailErrorContainer>
          <EmailError>{emailError}</EmailError>
        </EmailErrorContainer>
        <ButtonWithIcon
          iconLeft={<PapperplaneIcon fill={'rgba(225, 36, 104, 1)'} />}
          variant={'outline'}
          loading={isLoading}
          onClick={onSubmitEmail}
          text={t('get_tag_modal.email_steps.send')}
        />
      </EmailDeveloperContainer>
    </GetTagInstructionsContainer>
  )
}
